module.exports = __webpack_public_path__ + "img/stripe.2ae0b55.svg";